import { render } from "./BancoHorasTipoTabPage.vue?vue&type=template&id=69b49276"
import script from "./BancoHorasTipoTabPage.vue?vue&type=script&lang=js"
export * from "./BancoHorasTipoTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__